import * as React from "react";
import * as moment from "moment";
import * as firebase from 'firebase';

import {Avatar, Col, Row} from "antd";

export interface IMessage {
  author: string;
  messageText: string;
  timestamp: firebase.firestore.Timestamp;
}

interface IProps {
  message: IMessage,
  showAuthor: boolean;
}

export const Message = (props: IProps) => {

  const {message, showAuthor} = props;

  const avatar = () => (
      <Avatar icon='user' className='avatar'/>
  );

  const author = () => (
    <span className='primary-color'>{message.author}</span>
  );

  const time = message.timestamp ? moment.unix(message.timestamp.seconds).format('HH:mm') : '-';

  return(
    <div className='message'>
      <Row gutter={16}>
        <Col span={1} lg={2} xl={1}>
          {showAuthor ? avatar() : ''}
        </Col>
        <Col span={20} className='author' style={{paddingLeft: '15px'}}>
          {showAuthor ? author() : ''}
          <p>{message.messageText}</p>
        </Col>
        <Col span={3} lg={2} xl={3}>
          <span className='secondary-text fr'>{time}</span>
        </Col>
      </Row>
    </div>
  )
};
